import gql from 'graphql-tag';

export const GET_VENDOR_OPPORTUNITY_REVENUE_BREAKDOWN = gql`
  query VendorOpportunityRevenueBreakdown($vendorOpportunityId: String!) {
    vendorOpportunityRevenueBreakdown(vendorOpportunityId: $vendorOpportunityId) {
      totalEquipmentRevenue
      totalFinanceRevenue
      totalProtectionProductsRevenue
      selectedProposalId
      financeRevenueBreakdown {
        submissionId
        lender
        financeProgramId
        financeProgramName
        fundedAmount
        financeMarkup
        dateFounded
        dateCommissionReceived
        financeCommission
        docFeeAmount
      }
      protectionProductsCategoriesRevenueBreakdown {
        otherProducts {
          fromProposal {
            markup
            totalCost
          }
          additional {
            markup
            totalCost
          }
          markup
          totalCost
        }
        roadsideProducts {
          fromProposal {
            markup
            totalCost
          }
          additional {
            markup
            totalCost
          }
          markup
          totalCost
        }
        insuranceProducts {
          fromProposal {
            markup
            totalCost
          }
          additional {
            markup
            totalCost
          }
          markup
          totalCost
        }
        serviceContractProducts {
          fromProposal {
            markup
            totalCost
          }
          additional {
            markup
            totalCost
          }
          markup
          totalCost
        }
        gapProducts {
          fromProposal {
            markup
            totalCost
          }
          additional {
            markup
            totalCost
          }
          markup
          totalCost
        }
      }
    }
  }
`;
